import { useRef, useState } from 'react';
import { isWeb } from '@helpers';
import { getPersistedTableConfig } from '@components/common/DataGrid';
import { useGridApiRef } from './useGridApiRef';

export const useTableTools = (tableName?: string) => {
  const apiRef = useGridApiRef();

  const urlParams = new URLSearchParams(isWeb ? window?.location?.search : {});

  const initialSortModel = urlParams.get('sortModel');
  const initialOrderBy = urlParams.get('orderBy');

  const persisted = getPersistedTableConfig(tableName);

  const [columnVisibilityModel, setColumnVisibilityModel] = useState<Record<string, boolean> | null>(
    persisted?.columnVisibilityModel || null
  );
  const [filter, setFilter] = useState(null);
  const [filterModel, setFilterModel] = useState(persisted?.filterModel || null);
  const [orderBy, setOrderBy] = useState<string[] | null>(
    initialOrderBy ? JSON.parse(initialOrderBy) : persisted?.orderBy || null
  );
  const [sortModel, setSortModel] = useState<{ field: string; sort: string }[] | null>(
    initialSortModel ? JSON.parse(initialSortModel) : persisted?.sortModel || null
  );
  const [oDataFilter, setODataFilter] = useState(persisted?.oDataFilter || null);

  const usedODataFilter = useRef<string>(persisted?.oDataFilter || '');
  const customAnchorRef = useRef(null);

  return {
    apiRef,
    columnVisibilityModel,
    setColumnVisibilityModel,
    filter,
    setFilter,
    filterModel,
    setFilterModel,
    orderBy,
    setOrderBy,
    sortModel,
    setSortModel,
    oDataFilter,
    setODataFilter,
    usedODataFilter,
    customAnchorRef,
  };
};
